import { Fragment, useCallback, useMemo } from 'react';

import {
  DEFAULT_PAYMENT_RULE_RENDER,
  PAYMENT_RULES,
  PaymentRuleOptions,
} from 'constants/payment-rule-constants';
import { useOrderContext } from 'hooks';

type Props = {
  requisitesCountry?: string;
};

export const PaymentDetailsRules: React.FC<Props> = ({ requisitesCountry }) => {
  const {
    isTSBP,
    isSBP,
    isSIM,
    isCard2Card,
    isTCard2Card,
    customerBankName,
    customerBank,
    tradeMethod,
    order,
  } = useOrderContext();

  const paymentRuleOptions: PaymentRuleOptions = useMemo(
    () => ({
      isTSBP,
      isSBP,
      isSIM,
      isCard2Card,
      isTCard2Card,
      customerBankName,
      customerBank,
      fiatCurrency: tradeMethod?.fiatCurrency,
      requisitesCountry,
      requisitesBank: order?.requisites?.bank,
      requisitesBankName: order?.requisites?.bankName,
      sameBank: order?.requisites?.sameBank,
    }),
    [
      isTSBP,
      isSBP,
      isSIM,
      isCard2Card,
      isTCard2Card,
      customerBankName,
      customerBank,
      tradeMethod,
      requisitesCountry,
      order,
    ],
  );

  const renderRules = useCallback(() => {
    const paymentRule = PAYMENT_RULES.find((rule) =>
      rule.isMatch(paymentRuleOptions),
    );
    if (paymentRule) {
      return paymentRule.render(paymentRuleOptions);
    }
    return DEFAULT_PAYMENT_RULE_RENDER(paymentRuleOptions);
  }, [paymentRuleOptions]);

  return <Fragment>{renderRules()}</Fragment>;
};
